import { getConfig } from '@shared/utils/window';

export const ACTING_USER_COOKIE = 'kato_acting_uid';
export const ACTING_USER_MISMATCH_EVENT = 'kato:acting-user-mismatch';

export const getActingUserIdCookie = () => {
  const entry = document.cookie.split('; ').find((cookie) => cookie.startsWith(`${ACTING_USER_COOKIE}=`));
  return entry?.split('=')[1];
};

export const isActingUserStale = () => {
  const cookieValue = getActingUserIdCookie();
  const bootstrappedId = getConfig()?.user?.id?.toString() ?? '';
  return cookieValue !== undefined && cookieValue !== bootstrappedId;
};

export const dispatchActingUserMismatch = () => {
  window.dispatchEvent(new CustomEvent(ACTING_USER_MISMATCH_EVENT));
};
